import { Message } from "../../../../../models";

export const UPDATE_LATEST_MESSAGE = 'UPDATE_LATEST_MESSAGE'

export interface UpdateLatestMessageAction {
    type: string
    chatUId: string
    message: Message
}
export const updateLatestMessage = (chatUId: string, message: Message): UpdateLatestMessageAction => ({
    type: UPDATE_LATEST_MESSAGE,
    chatUId,
    message
})
